// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__zlict","text":"Footer_text__Ygitu"};